export const IDLE_THRESHOLD = 150;

export const DEFAULT_STATE = {
	isScrollingX: false,
	isScrollingY: false,
} as const;
